import React, { useState } from "react";
import { View } from "react-native";
import { Text, TouchableRipple } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import { Feather } from "@expo/vector-icons";
import { Modal } from "../../components";
import { colors } from "../../../theme";
import MultipleDuesInvoicesModal from "./MultipleDuesInvoicesModal";
import { openBrowser } from "../utils";
import { Order } from "./InvoiceListScreen";
import { useFeatureFlags } from "../../hooks/useFlagr";

type PaymentOptionsModalProps = {
  onDismiss(): void;
  visible: boolean;
  order: Order | null;
  pastDueOrderTitle: string;
};

const PaymentOptionsModal = ({ onDismiss, visible, order, pastDueOrderTitle }: PaymentOptionsModalProps) => {
  const flags = useFeatureFlags();
  const isCurrentDueOrder = order?.isCurrentDue;
  const [multipleDuesInvoicesModalVisible, setMultipleDuesInvoicesModalVisible] = useState(false);

  const navigation = useNavigation();
  const onPress = ({ assignProxy, showProxyModal }: { assignProxy: boolean; showProxyModal?: boolean }) => {
    if (isCurrentDueOrder) {
      setMultipleDuesInvoicesModalVisible(true);
    } else {
      navigation.navigate("Dues", {
        ...(flags["dues-order-lookup"] && { orderId: order?.id }),
        assignProxy: assignProxy,
        showProxyModal: showProxyModal,
      });
    }
    onDismiss();
  };
  const options = [
    {
      icon: <Feather name="credit-card" size={32} color={colors.ink.darkest} />,
      title: "Pay Dues",
      description: "Make a full or partial dues payment.",
      onPress: () => onPress({ assignProxy: false, showProxyModal: false }),
    },
    {
      icon: <Feather name="user-plus" size={32} color={colors.ink.darkest} />,
      title: "Assign Proxy",
      description: "Request a proxy to make a full or partial dues payment on your behalf.",
      onPress: () => onPress({ assignProxy: true }),
    },
    {
      icon: <Feather name="printer" size={32} color={colors.ink.darkest} />,
      title: "Print Invoice",
      description: "Print your dues invoice to pay by mail.",
      onPress: () => order?.pdfUrl && openBrowser(order.pdfUrl)(),
      disabled: !order?.pdfUrl,
    },
  ];
  return (
    <>
      <Modal visible={visible} onDismiss={onDismiss} title="Select Payment Option">
        <View className="p-6 flex-col gap-4">
          {options.map((option) => (
            <TouchableRipple
              key={option.title}
              testID={`payment-option-bank`}
              onPress={option.onPress}
              className={`rounded-lg p-4 border-[2px] border-primary-lighter ${
                option.disabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <View>
                <View className="flex flex-col items-start">
                  {option.icon}
                  <Text className="text-regular-tight font-500 mb-1">{option.title}</Text>
                  <Text className="text-small-tight text-ink-lighter font-400 ">{option.description}</Text>
                </View>
              </View>
            </TouchableRipple>
          ))}
        </View>
      </Modal>
      <MultipleDuesInvoicesModal
        visible={multipleDuesInvoicesModalVisible}
        onDismiss={() => setMultipleDuesInvoicesModalVisible(false)}
        pastDueOrderTitle={pastDueOrderTitle}
      />
    </>
  );
};

export default PaymentOptionsModal;
